import React from 'react';
import { Link } from 'react-router-dom'

const proyects = [
    { P: 'runordie', L: '/runordie' },
    
   
   
    
];


class   Game extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">





                    <div className="sectionWeb">


                        <div className="titleSectionWeb">
                            <h1>Video games</h1>

                        </div>
                        <svg> <rect></rect> </svg>


                        <div className="listP">

                            {proyects.map(pro => (
                                <Link to={pro.L} >

                                    <div key={pro} className={pro.P}>

                                    </div>
                                </Link>


                            ))}

                        </div>



                    </div>




                </div>


            </React.Fragment>
        );
    }
}

export default Game;